import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

// const basePath = '/MarkServer/json/mark'
const basePath = '/HomeworkService/'

/**
 * 作业列表
 * @author wangk 2018-12-05T09:56:37+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const listClassWork = (params = {}) => {
  return axios.post(`${basePath}listClassWork`, params)
    .then(res => res.data)
}

/**
 * 获取作业状态
 * 200001,图片格式不支持
  200002，图片内容编码有误
  200009,整图识别处理失败
  200014,图片大小超过4mb限制
  200015,图片长超过6000像素限制
  200016,图片宽超过6000像素限制
  200017,图片长宽比例超过50：1限制
  200018,图片长宽比例超过1:4限制
 * @author wangk 2018-12-05T09:56:37+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getClassWorkStatus = (params = {}) => {
  return axios.post(`${basePath}getClassWorkStatus`, params)
    .then(res => res.data)
}

/**
 * 上传作业
 * @author wangk 2018-12-05T09:56:37+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const batchSubmit = (params = {}) => {
  return axios.post(`${basePath}batchSubmit/${params.taskId}`, params.formData)
    .then(res => res.data)
}

export {
  listClassWork,
  getClassWorkStatus,
  batchSubmit
}



// WEBPACK FOOTER //
// ./src/model/homework-model.js